import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
	decalerEcheance,
	decalerEcheanceReset,
} from "../../store/actions/entretienActions"
import * as Addons from "../../utilities/Addons"
import { COLORS } from "../../utilities/Constants"
import { generalStyles as gs } from "../styles/styles"
import CustomModal from "../basics/interface/CustomModal"
import InputV2 from "../basics/input/InputV2"

const styles = {
	intro: { fontSize: 13, color: COLORS.textMuted, marginBottom: 16 },
	field: { marginBottom: 14 },
	label: {
		fontSize: 11,
		fontWeight: 600,
		color: COLORS.textLight,
		textTransform: "uppercase",
		letterSpacing: "0.05em",
		display: "block",
		marginBottom: 6,
	},
	input: { ...gs.input, width: "100%" },
}

// Décale UNE échéance ouverte (ce véhicule seulement). Champs selon le plan :
// date si période calendaire (ou unique), km si intervalle km.
const EntretienDecalerModal = ({ echeance: e, onClose }) => {
	const dispatch = useDispatch()
	const { decalerEcheance: state } = useSelector((s) => s.entretienInfo)
	const avecDate =
		e.entretien.unique || !!(e.suivante && e.suivante.periode) || !!e.date
	const avecKm =
		!e.entretien.unique &&
		(!!(e.suivante && e.suivante.cycle_km) || e.km_cible != null)
	const [date, setDate] = useState(e.date || "")
	const [km, setKm] = useState(e.km_cible == null ? "" : String(e.km_cible))
	// Bouton déjà dans un modal : switch « Enregistrer » → « Confirmer ? »
	// (src/CLAUDE.md), annulé dès que la saisie change ou que le save échoue.
	const [confirm, setConfirm] = useState(false)

	useEffect(() => {
		if (state.saved) {
			dispatch(decalerEcheanceReset())
			onClose()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state.saved])
	useEffect(() => {
		setConfirm(false)
	}, [date, km, state.error])

	const close = () => {
		dispatch(decalerEcheanceReset())
		onClose()
	}
	const valide = (avecDate && date !== "") || (avecKm && km !== "")
	const save = () => {
		if (!confirm) {
			setConfirm(true)
			return
		}
		dispatch(
			decalerEcheance({
				cycle_id: e.cycle_id,
				date: avecDate ? date : "",
				km_cible: avecKm ? km : "",
			}),
		)
	}

	return (
		<CustomModal
			title="Décaler l'échéance"
			subtitle={`${e.entretien.label} · ${e.vehicule.label}`}
			onClose={state.saving ? () => {} : close}
			showCloseButton={!state.saving}
			maxWidth={420}
			buttons={[
				{
					title: "Annuler",
					styleName: "secondary",
					onClick: close,
					disabled: state.saving,
				},
				{
					title: confirm ? "Confirmer ?" : "Enregistrer",
					styleName: "primary",
					onClick: save,
					disabled: !valide,
					loading: state.saving,
				},
			]}
		>
			<div style={styles.intro}>
				Seule l'échéance de ce véhicule change ; les autres véhicules du
				plan gardent les leurs.
			</div>
			{avecDate && (
				<div style={styles.field}>
					<label style={styles.label}>Date d'échéance</label>
					<InputV2
						type="date"
						style={styles.input}
						value={date}
						onChange={(ev) => setDate(ev.target.value)}
					/>
				</div>
			)}
			{avecKm && (
				<div style={styles.field}>
					<label style={styles.label}>Seuil (km)</label>
					<input
						type="text"
						style={styles.input}
						value={km}
						onChange={(ev) => setKm(ev.target.value)}
						onKeyDown={(ev) => Addons.typeNumber(ev)}
					/>
				</div>
			)}
		</CustomModal>
	)
}

export default EntretienDecalerModal
